import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import LoanTable from "../components/LoanTable";
import RecordPaymentDialog from "../components/RecordPaymentDialog";
import SalesScopeSelector from "../components/SalesScopeSelector";
import api, { formatApiError } from "../lib/api";

export default function BlacklistPageV2() {
  const [loans, setLoans] = useState([]);
  const [scopeId, setScopeId] = useState("");
  const [paymentLedger, setPaymentLedger] = useState(null);

  const loadLoans = useCallback(async () => {
    try {
      const response = await api.get(`/loans${scopeId ? `?owner_id=${scopeId}` : ""}`);
      setLoans(response.data);
    } catch (error) {
      toast.error(formatApiError(error));
    }
  }, [scopeId]);

  useEffect(() => {
    loadLoans();
  }, [loadLoans]);

  const openPayment = async (loan) => {
    try {
      const response = await api.get(`/loans/${loan.id}/repayment-ledger`);
      setPaymentLedger(response.data);
    } catch (error) {
      toast.error(formatApiError(error));
    }
  };

  return (
    <div className="page" data-testid="blacklist-page">
      <header className="page-header">
        <div>
          <div className="eyebrow">Risk register</div>
          <h1>Blacklisted loans</h1>
          <p>Choose an agent to view their permitted downline customer blacklist records.</p>
        </div>
      </header>
      <SalesScopeSelector
        value={scopeId}
        onChange={setScopeId}
        testId="blacklist-agent-select"
      />
      <LoanTable
        loans={loans}
        mode="blacklist"
        onRepayment={openPayment}
        onBlacklist={() => {}}
      />
      <RecordPaymentDialog
        ledger={paymentLedger}
        open={Boolean(paymentLedger)}
        onClose={() => setPaymentLedger(null)}
        onDone={loadLoans}
      />
    </div>
  );
}